/* eslint-disable no-underscore-dangle */
import dayjs, { type Dayjs } from '@/utilities/dayjs-config'
import type { Campaign } from './campaign'
import type { CampaignWeek as PopsCampaignWeek } from '@/types/pops'
import { $campaigns } from '@/stores/campaign/stores'

export class CampaignWeek {
  campaignId: number
  campaignStartWeek: Dayjs
  campaignWeekNumber: number
  isDualOptIn: boolean
  isDetoxPlusWeek: boolean
  week: Dayjs
  #campaign: Campaign | undefined

  constructor(rawCampaign: PopsCampaignWeek) {
    this.campaignId = rawCampaign.campaign_id
    this.campaignStartWeek = dayjs(rawCampaign.campaign_start_week)
    this.campaignWeekNumber = rawCampaign.campaign_week_number
    this.isDualOptIn = rawCampaign.is_dual_opt_in
    this.isDetoxPlusWeek = rawCampaign.is_detox_plus_week
    this.week = dayjs(rawCampaign.week)
  }

  get campaign() {
    if (this.#campaign) return this.#campaign

    this.#campaign = $campaigns.get()[this.campaignId]

    return this.#campaign
  }
}
